import { app, logo, esc, icon, inputValue, target } from '../dom.ts';
import { brand, titled } from '../../brand.ts';
import { standalone } from '../install.ts';
import { go } from '../router.ts';
import { saved } from '../saved.ts';
import { startManual, startScan } from './new-split.ts';
import { POINTS_LINE } from '../../fee-copy.ts';

export function homeView(): void {
  document.title = titled('');
  const profile = saved.profile();
  const splits = saved.splits();
  // Came from a friend's "Put it on my home screen" on iPhone: the last two taps, until it's added.
  const addHint = new URLSearchParams(location.search).get('keep') === 'home' && !standalone();
  app.innerHTML = `
    <div class="bar">${logo}<span>${profile.name ? 'Hi, ' + esc(profile.name) : ''}</span></div>
    <div class="body">
      ${addHint ? `<div class="note" id="addHint" style="font-size:16px">Now tap <b>Share</b> ${icon.share}, then <b>Add to Home Screen</b>.</div>` : ''}
      <div class="stack" style="padding-top:16px">
        <span class="lbl">The check is here</span>
        <h1 class="h h-xl">The math isn't your problem.</h1>
        <p class="lede">Friends scan, tap what they had and pay you back on Venmo or Cash App. No app for them. No spreadsheet for you.</p>
      </div>
      <div class="steps"><ol>
        <li><b>1</b><div><div style="font-weight:600">Scan the receipt</div><div class="sub">We read every line, the tax and the total.</div></div></li>
        <li><b>2</b><div><div style="font-weight:600">Friends scan your code</div><div class="sub">They tap their own items. No app needed.</div></div></li>
        <li><b>3</b><div><div style="font-weight:600">Watch the money come in</div><div class="sub">See who paid and remind who didn't.</div></div></li>
      </ol></div>
      ${splits.length ? `<div><div class="lbl">Your splits</div>${splits.slice(0, 5).map((s) => `
        <a class="person" href="/p/${esc(s.code)}" data-go style="text-decoration:none;color:inherit">
          <div class="who"><div>${esc(s.venue)}</div><div class="sub">${esc(s.date || '')}</div></div>
          <span class="amt sub">${esc(s.code)}</span>
        </a>`).join('')}</div>` : ''}
      <form id="codeForm" class="stack" autocomplete="off">
        <label class="lbl" for="code">Someone else paid? Enter their code</label>
        <div class="row2"><input id="code" class="input amt" placeholder="LUPA42" autocapitalize="characters" maxlength="8"><button class="btn2" style="flex:0 0 96px">Open</button></div>
      </form>
      <p class="sub" style="margin:0;font-size:14px">Run a restaurant? <a href="/restaurants" data-go>See what ${brand.name} does for you</a></p>
    </div>
    <div class="foot">
      <label class="btn file-btn">${icon.camera} Scan receipt<input type="file" accept="image/*" capture="environment" data-file aria-label="Scan receipt"></label>
      <p class="hint" id="pointsLine" style="text-align:center;margin:0">${esc(POINTS_LINE)}</p>
      <div class="row2">
        <label class="btn2 file-btn">Choose a photo<input type="file" accept="image/*" data-file aria-label="Choose a photo"></label>
        <button class="btn2" data-act="manual">Type it in</button>
      </div>
    </div>`;

  app.onchange = (e) => {
    const input = e.target;
    if (input instanceof HTMLInputElement && input.matches('[data-file]') && input.files?.[0]) void startScan(input.files[0]);
  };
  app.onclick = (e) => { if (target(e, '[data-act=manual]')) startManual(); };
  app.onsubmit = (e) => {
    e.preventDefault();
    const code = inputValue('code').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    if (code) go('/s/' + code);
  };
}
